
<template>
  <div class="padded">

    <el-row style="padding-bottom: 0.432em;">
      <el-col :span="18">
        <h3><i class="fa fa-store-alt" />&nbsp;{{pluralise('Tenancy', tenancy.length)}}</h3>
      </el-col>
      <el-col :span="4" align="right">
        <tenancy-action
          v-if="isManager('property|finance') && !readOnly"
          :adding="true"
          @update="saved"
          :site-data="rowData" />
        </el-col>

        </el-col>
    </el-row>


    <div v-if="tenancy.length === 0">

      <div v-if="loading">
        <center><span class="fa fa-spinner fa-spin" /></center>
      </div>
      <div v-else>
        <center>
          <h3>No tenancy information found&nbsp;</h3>
        </center>
      </div>

    </div>


    <div v-else>

      <div v-if="tenancy.length === 1">

        <tenancy
            :row-data="rowData"
            :tenancy-data="tenancy[0]"
            :index="0"
            :show-agreement="showAgreement"
            :editable="editable"
            :read-only="readOnly"
            @update="saved"
            @deleted="deleted" />

      </div>

      <div v-else>
        <el-alert type="info" :title="'Site has ' + plural('landowner', tenancy.length, true)" :closable="false" show-icon />

        <el-collapse accordion v-model="selected" v-for="(t, index) in tenancy" :key="index">

           <el-collapse-item :name="index">
             <template slot="title">
               <span class="text-primary">{{(index+1) + ')'}}&nbsp;<b>{{t.owner && t.owner.name ? t.owner.name : 'Not Found'}}</b></span>
             </template>

             <tenancy
              :row-data="rowData"
              :tenancy-data="t"
              :index="index"
              :show-agreement="showAgreement"
              :editable="editable"
              :read-only="readOnly"
              @update="saved"
              @deleted="deleted" />

           </el-collapse-item>

        </el-collapse>
      </div>

    </div>
  </div>
</template>


<script>
import ArrayMixins from '@/mixins/ArrayMixins'
import FormattingMixins from '@/mixins/FormattingMixins'
import SiteMixins from '@/mixins/SiteMixins'

import TenancyAction from '@/components/actions/TenancyAction'
import Tenancy from '@/components/property/Tenancy'

export default {

  mixins: [ArrayMixins, FormattingMixins, SiteMixins],

  components: {
    TenancyAction,
    Tenancy
  },

  props: {

    rowData: {
      type: Object,
      required: true
    },

    showAgreement: {
      type: Boolean,
      default: true
    },

    editable: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }


  },



  methods: {

    saved (data, adding = false) {

      if (adding && data.id) {

        this.tenancy.push(data)

      } else {

        let i = this.findIndex('id', data.id, this.tenancy)

        if (i && this.tenancy[i]) {
          this.tenancy[i] = data
        }

      }

    },

    deleted (i, id) {

      if (i >= 0) {
        this.tenancy = this.arrayRemove(this.tenancy, i)
      }

    },


    errorTenancy (err) {
      this.loading = false
      console.err(err)
    },


    fetchTenancy (data) {
      this.loading = false
      this.tenancy = data
    }

  },



  data () {

    return {

      localSite: this.rowData,
      tenancy: [],
      loading: true,
      selected: 0

    }

  },



  mounted () {

    this.findSiteTenancy(this.rowData.id, this.fetchTenancy, this.errorTenancy)

  }

}

</script>



// WEBPACK FOOTER //
// SiteTenancy.vue?3db76e1c